var map = {
	"./black/duijiang.png": "i4ep",
	"./blue/duijiang.png": "KhF4",
	"./white/duijiang.png": "6wnm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fxP4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/duijiang\.png$
// module id = fxP4
// module chunks = 24